<div class="heading">
  <h2>الگوی تاریخی خودرو</h2>
  <small>مقایسه میانگین و پراکندگی در وضعیت‌های مختلف</small>
</div>

<ng-container *ngIf="rows.length; else empty">
  <section class="baseline-state" *ngFor="let row of rows" [attr.aria-label]="row.label">
    <div class="state-heading">
      <strong>{{ row.label }}</strong>
      <span class="muted"><bdi>{{ row.samples !== null ? (row.samples | number:'1.0-0':'en-US') : '—' }}</bdi> نمونه تاریخی</span>
    </div>
    <div class="metrics">
      <div class="metric">
        <span>میانگین تاریخی</span>
        <b dir="ltr">{{ row.historicalAverage !== null ? (row.historicalAverage | number:'1.2-2':'en-US') + ' V' : '—' }}</b>
      </div>
      <div class="metric">
        <span>میانگین امروز</span>
        <b dir="ltr">{{ row.todayAverage !== null ? (row.todayAverage | number:'1.2-2':'en-US') + ' V' : '—' }}</b>
      </div>
      <div class="metric">
        <span>تفاوت</span>
        <b dir="ltr" [class.near]="row.zScore !== null && row.zScore >= -2 && row.zScore <= 2" [class.far]="row.zScore !== null && (row.zScore < -2 || row.zScore > 2)">{{ row.difference !== null ? (row.difference > 0 ? '+' : '') + (row.difference | number:'1.2-2':'en-US') + ' V' : '—' }}</b>
      </div>
    </div>
    <p class="details">
      انحراف معیار تاریخی: <bdi>{{ row.deviation !== null ? (row.deviation | number:'1.3-3':'en-US') + ' V' : '—' }}</bdi>
      · فاصله میانگین امروز از الگو: <bdi>{{ row.zScore !== null ? (row.zScore > 0 ? '+' : '') + (row.zScore | number:'1.2-2':'en-US') + ' σ' : '—' }}</bdi>
    </p>
    <p class="reliability" *ngIf="row.reliable !== true">{{ row.reliable === false ? 'الگوی تاریخی این وضعیت طبق ارزیابی سرور قابل اتکا نیست.' : 'قابلیت اتکای الگوی تاریخی مشخص نشده است.' }}</p>
  </section>
  <p class="note">میانگین امروز با الگوی تاریخی همان کد وضعیت مقایسه می‌شود؛ فاصله استاندارد فقط برای الگوی قابل اتکا با انحراف معیار بیشتر از صفر محاسبه می‌شود.</p>
</ng-container>

<ng-template #empty><div class="empty" role="status">الگوی تاریخی برای این خودرو موجود نیست.</div></ng-template>
